import { render, staticRenderFns } from "./BankAccountInformationForm.vue?vue&type=template&id=e085e4fe&"
import script from "./BankAccountInformationForm.vue?vue&type=script&lang=js&"
export * from "./BankAccountInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports